import { render, staticRenderFns } from "./IconCirclePlus.vue?vue&type=template&id=2b284a82&functional=true&"
import script from "./IconCirclePlus.vue?vue&type=script&lang=js&"
export * from "./IconCirclePlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports